<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['ad.name']">
              <a-input v-model="queryParam.title" :placeholder="language['ad.must.name']" allowClear></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="是否第三方内容">-->
<!--              <j-dict-select-tag placeholder="请选择是否第三方内容" v-model="queryParam.isThird" dictCode="hhemp_isthird"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['platform.roleUser.columns2.status']">
              <j-dict-select-tag :placeholder="language['column.pleaseChoose']+language['platform.roleUser.columns2.status']"  v-model="queryParam.status" dictCode="hhemp_ad_status" allowClear/>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="!onlyView">
      <a-button @click="handleAdd" type="primary" v-has="'cmsbanner:insert'"  icon="plus">{{this.language['common.insertButton']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" v-has="'cmsbanner:batchUpdown'" @click="batchPublish('1',language['ad.online'])"><a-icon type="delete"/>{{language['ad.online']}}</a-menu-item>
          <a-menu-item key="2" v-has="'cmsbanner:batchUpdown'"  @click="batchPublish('0',language['ad.offline'])"><a-icon type="delete"/>
            {{ language['ad.offline'] }}</a-menu-item>
          <a-menu-item key="1" v-has="'cmsbanner:batchDel'"  @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;max-height:160px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            title="图片"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="publisher" slot-scope="text,record">
          <span v-if="record.publishStatus=='published'">
            <p>{{record.publisherName}}</p>
            <p >({{record.publisher}}) </p>
          </span>
        </span>
        <span slot="action" slot-scope="text, record" v-if="!onlyView">
<!--          <a @click="handleContent(record)">查看</a>-->
            <a @click="publish(record)" v-has="'cmsbanner:updown'" v-if="record.status=='0'">{{language['ad.online']}}</a>
          <a @click="unpublish(record)" v-has="'cmsbanner:updown'" v-if="record.status=='1'">{{ language['ad.offline'] }}</a>
          <a-divider type="vertical" v-has="'cmsbanner:updown'" />
            <a @click="handleEdit(record)" v-has="'cmsbanner:edit'">{{ language['common.edit'] }}</a>
          <a-divider type="vertical" v-has="'cmsbanner:edit'" />



            <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'cmsbanner:detail'">
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'cmsbanner:delete'">
                   <a-popconfirm :title="language['esg.IsDeleted']" @confirm="() => handleDelete(record.id)">
                               <a>{{language['ispforum.delete']}}</a>
          </a-popconfirm>

              </a-menu-item>
            </a-menu>
          </a-dropdown>



        </span>


      </a-table>
    </div>

    <cms-banner-modal ref="modalForm" @ok="modalFormOk" :colid="this.colid"></cms-banner-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CmsBannerModal from './modules/CmsBannerModal'
  import { httpAction,getAction } from '@/api/manage'
  import { filterObj } from '@/utils/util';

  export default {
    name: 'CmsBannerlList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      CmsBannerModal,
    },
    props: {
      colid: String,
      onlyView: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const { language } = this.$store.getters;
      return language&&{
        isDisable:false,
        description: 'cms_banner管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:language['hhemp.ad.no'],
            align:"center",
            dataIndex: 'bannerCode',
            width: 150
          },
          {
            title: language['ad.name'],
            align: "center",
            dataIndex: 'title',
            width: 300,
            ellipsis: true,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title:language['ad.status'],
            align:"center",
            dataIndex: 'status',
            width: 150,
            customRender:function (text,record){
              if(text=='0'){
                return language['labor.unPublished']
              }else{
                return language['labor.published']
              }
            }
          },
          {
            title:language['emp.apptype.entrance'],
            align:"center",
            dataIndex: 'entrance',
            customRender:function (entrance,record){
              return entrance.entranceName;
            }
          },
          {
            title:language['emp.col.publisher'],
            align:"center",
            dataIndex: 'publisher'
          },
          {
            title:language['emp.col.publishTime'],
            align:"center",
            dataIndex: 'publishTime',
            width: 250,
            customRender:function (text,record) {
              if(record.status=='1'){
                return !text?"":(text.length>19?text.substr(0,19):text);
              }else{
                 return "";
              }
            }
          },
          {
            title:language['emp.apptype.sort'],
            align:"center",
            dataIndex: 'sortNo'
          },
          {
            title: language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:250,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/banner/banners",
          delete: "/hhemp/banner/banners",
          deleteBatch: "/hhemp/banner/banners/batch",
          publish: "/hhemp/banner/publishstatus",
          publishBatch: "/hhemp/banner/publishstatus/batch",
        },
        dictOptions:{},
        superFieldList:[],
        cols:[{
          id:'',
          colName:''
        }],
        applicationCode:'hhemp',
        previewVisible: false,
        previewImage: '',
        disableMixinCreated: false,
      }
    },
    created() {

      /*this.$set(this.dictOptions, 'publishStatus', [{text:'是',value:'Y'},{text:'否',value:'N'}])*/
      this.getColList();
      /*let that = this;
      if(this.$route.query.colid != undefined){
        this.queryParam.colId = this.$route.query.colid;
        this.loadData();
      }else{
        this.loadData();
      }*/



      //如果只是查看权限，就不显示后面操作按钮
      if(this.onlyView){
        this.columns=this.columns.slice(0, this.columns.length - 1)
      }

    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      goback(){
        this.$parent.tabChange(null);
      },
      batchPublish(status,title){
        var that = this;
        //上架
        this.$confirm({
          title:title,
          content:this.language['common.sure']+title+this.language['common.selected.data']+"?",
          onOk: function(){

            if (that.selectedRowKeys.length <= 0) {
              that.$message.warning(this.language['tip.messageSelectRecord']);
              return;
            } else {
              var ids = "";
              for (var a = 0; a < that.selectedRowKeys.length; a++) {
                ids += that.selectedRowKeys[a] + ",";
              }
              getAction(that.url.publishBatch,{ids:ids,status:status}).then((res)=>{
                if(res.success){
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                }else{
                  that.$message.warning(res.message);
                }
              });

            }
          }
        });
      },
      initDictConfig(){
      },
      getQueryParams() {
        // 路由参数
        if(this.colid!=null) {
          this.queryParam.colId = this.colid;
          this.isDisable=true;
        }
        if(this.$route.query.colid != undefined){
          this.queryParam.colId = this.$route.query.colid;
          this.$route.query.colid = null;
        }
        //获取查询条件
        let sqp = {}
        if(this.superQueryParams){
          sqp['superQueryParams']=encodeURI(this.superQueryParams)
          sqp['superQueryMatchType'] = this.superQueryMatchType
        }
        var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getColList(){
        httpAction("/hhemp/col/cmscoltblAll", "", "get").then((res) => {
          if (res.success) {
            this.cols = res.result;
          }
        })
      },
      publish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language['emp.col.status.publish'],
          content:this.language['emp.col.status.sureUpShelf'],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'1'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      unpublish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language['ad.offline'],
          content:this.language['emp.apptype.sureDownShelf'],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'0'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      handleContent(record){
        this.$refs.ShowContent.detail(record,'ShowContent');
      },
    }
    ,mounted() {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
